import { Button } from "~components";
import { Css } from "~generated/css";
import { useCurrentUser } from "./utils/hooks/useCurrentUser";

type UnauthorizedUserTypeLandingPageProps = {
  handleSignOut: () => Promise<void>;
};

export function UnauthorizedUserTypeLandingPage({ handleSignOut }: UnauthorizedUserTypeLandingPageProps) {
  const { currentUser } = useCurrentUser();

  return (
    <div css={Css.df.fdc.jcc.gap4.aic.tac.vh100.wPx(600).mxa.ifMobile.w100.gap2.px2.$}>
      <h1>&#x1F914; Something doesn't seem quite right here&hellip;</h1>
      <div css={Css.df.gap1.ifMobile.fdc.$}>
        <div>Current user: {currentUser?.email}</div>
        <div>Type: {currentUser?.type}</div>
      </div>
      <p>
        You are not authorized to access this page. Please contact support at{" "}
        <a css={Css.tdu.blue700.ifMobile.$} href="mailto:product-support@homebound.com">
          {/* Note: this is a very jank way to force this link into its own line on mobile without pulling in useViewport for isMobile boolean */}
          <div css={Css.ifTabletAndUp.dn.$}>{"\n"}</div>
          product-support@homebound.com
          <div css={Css.ifTabletAndUp.dn.$}>{"\n"}</div>
        </a>{" "}
        if you believe this is an error, or log in with a different account.
      </p>
      <Button onClick={handleSignOut}>Sign Out</Button>
    </div>
  );
}
